import { render, staticRenderFns } from "./tencentIFrame.vue?vue&type=template&id=2819b17b&scoped=true"
import script from "./tencentIFrame.vue?vue&type=script&lang=js"
export * from "./tencentIFrame.vue?vue&type=script&lang=js"
import style0 from "./tencentIFrame.vue?vue&type=style&index=0&id=2819b17b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2819b17b",
  null
  
)

export default component.exports